import VSelectCardList from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardList', VSelectCardList),
};
